import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatLineSpacingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_line_spacing"}/>
}
